import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import { EventEmitter } from 'fbemitter';
import { GeckoModalService } from '../../';

import './modal-wrapper.scss';

class GeckoModalWrapper extends Component {
  state = {
    modal: false,
    content: null,
    params: {},
  };

  constructor(props) {
    super(props);

    // Create toast event emitter (if not already created)
    if (!GeckoModalService.emitter)
      GeckoModalService.emitter = new EventEmitter();

    GeckoModalService.emitter.addListener('open', (content, params) => {
      this.setState({
        modal: true,
        content: content,
        params: params,
      });
    });

    GeckoModalService.emitter.addListener('close', () => {
      this.setState({
        modal: false,
        content: null,
        params: {},
      });
    });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
    // Fire dismiss event (no param to be passed back)
    if (this.state.modal) GeckoModalService.emitter.emit('dismiss');
  }

  onEnter() {
    if (this.state.params.backdrop !== 'static') {
      // Overide backdrop setting
      const params = this.state.params;
      params.backdrop = 'static';
      this.setState({ params });

      const backdrop = document.getElementsByClassName('modal')[0];
      const dialog = document.getElementsByClassName('modal-dialog')[0];

      if (backdrop) {
        backdrop.addEventListener('mousedown', (e) => {
          // NOT inside dialog and IS a left click
          if (!dialog.contains(e.target) && e.which === 1) {
            return new GeckoModalService().close();
          }
        });
      }
    }
  }

  render() {
    if (!this.state.modal) return null;
    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle.bind(this)}
        size={this.state.params.size}
        backdrop={this.state.params.backdrop}
        keyboard={this.state.params.keyboard}
        wrapClassName="gecko-modal-wrapper"
        onEnter={this.onEnter.bind(this)}
      >
        {this.state.content ? this.state.content() : null}
      </Modal>
    );
  }
}

export default GeckoModalWrapper;
